import React, { useEffect, useCallback } from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import {
  Star, Newspaper, Megaphone, PlugCircleBolt, Suitcase,
} from '../../../ui/icons/classic/light';

export default function Menu(
  {
    menu,
    menuSettings,
    results,
    additionalData,
  }: componentTypes.MenuProps,
) {
  const id = encodeURIComponent(`white-instant-search-menu--${menuSettings.attribute}`)
    .toLowerCase()
    .replace(/\.|%[0-9a-z]{2}/gi, '');

  const goToUrl = useCallback((event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget;
    if (target && target instanceof HTMLAnchorElement && target.href) {
      window.location.href = target.href;
    }
    return false;
  }, []);

  useEffect(() => {
    if (menuSettings.hardRefresh) {
      Array
        .from(document.querySelectorAll(`#${id} .nav-link`))
        .forEach((link) => {
          if (link instanceof HTMLAnchorElement) {
            // eslint-disable-next-line no-param-reassign
            link.onclick = goToUrl;
          }
        });
    }
  }, [id, menuSettings.hardRefresh, goToUrl, menu.items]);

  const {
    items,
    refine,
    createURL,
  } = menu;

  const {
    classNames,
  } = menuSettings;

  const { search } = additionalData.translates;

  let totalCount = 0;
  let isRefined = false;
  Object.values(items).forEach((item) => {
    // @ts-ignore
    totalCount += item.count;
    if (item.isRefined) isRefined = true;
  });

  // eslint-disable-next-line no-underscore-dangle
  if (results.__isArtificial) {
    return (
      <div className="ais-Menu-list flex flex-wrap gap-3 animate-pulse">
        <div className="relative">
          <div className="btn btn-outline-dark btn-sm items-start ais-Menu-item--selected btn-dark">
            <span className="w-18 h-3.5 md:h-4.5 bg-white" />
            <span className="w-4 h-3.5 md:h-4.5 bg-white" />
          </div>
        </div>
        {Array.from({ length: 4 }, (_, index) => (
          <div className="relative" key={index}>
            <div className="btn btn-outline-dark btn-sm leading-none items-start">
              <span className="flex gap-x-4">
                <span className="w-4.5 h-3.5 md:h-4.5 bg-grey-300" />
                <span className="w-11 h-3.5 md:h-4.5 bg-grey-300" />
              </span>
              <span className="w-4 h-3.5 md:h-4.5 bg-grey-300" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <ul className={`ais-Menu-list ${classNames?.list || ''}`} id={id}>
      <li className={`ais-Menu-item ${classNames?.item || ''}`}>
        <a
          href={createURL('')}
          onClick={(event) => {
            event.preventDefault();
            refine('');
          }}
          className={`ais-Menu-link ${classNames?.link || ''} ${!isRefined && `ais-Menu-item--selected ${classNames?.selectedItem || ''}`}`}
        >
          <span className={`ais-Menu-label ${classNames?.label}`}>{Craft.t(search, 'Show all')}</span>
          <span className={`ais-Menu-count ${classNames?.count}`}>{totalCount}</span>
        </a>
      </li>
      {items.map((item) => (
        <li
          key={item.value}
          className={`ais-Menu-item ${classNames?.item || ''}`}
        >
          <a
            className={`ais-Menu-link ${classNames?.link || ''} ${item.isRefined && `ais-Menu-item--selected ${classNames?.selectedItem || ''}`}`}
            href={createURL(item.value)}
            onClick={(event) => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            <span className={`ais-Menu-label ${classNames?.label || ''}`}>
              {item.value === 'case' && (
                <Star iconClass="w-3.5 md:w-4.5" />
              )}
              {item.value === 'page' && (
                <Newspaper iconClass="w-3.5 md:w-4.5" />
              )}
              {item.value === 'insight' && (
                <Megaphone iconClass="w-3.5 md:w-4.5" />
              )}
              {item.value === 'job' && (
                <Suitcase iconClass="w-3.5 md:w-4.5" />
              )}
              {item.value === 'plugin' && (
                <PlugCircleBolt iconClass="w-3.5 md:w-4.5" />
              )}
              {item.label}
            </span>
            <span className={`ais-Menu-count ${classNames?.count || ''}`}>
              {item.count}
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}
